module.exports = __webpack_public_path__ + "static/google-play-badge-aad084eec181a7c0c9e99c008492e90d.svg";